import React from 'react'
import './i18n'
import ReactDOM from 'react-dom/client'
import 'rsuite/dist/rsuite.min.css'
import './style/index.less'
// import App from './App'
import reportWebVitals from './reportWebVitals'

const requireAll = (requireContext: __WebpackModuleApi.RequireContext) =>
  requireContext.keys().map(requireContext)

const req = require.context('./icons/svg', false, /\.svg$/)
requireAll(req)

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)

// 这里必须要懒加载组件，不然目录的i18n不生效
const App = React.lazy(() => import('./App'))
root.render(
  <App/>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
